import { createSlice } from '@reduxjs/toolkit';

const replyContextInitialState = {
  threadContext: {
    id: '',
    category: '',
    ownerId: '',
    createdAt: '',
    title: '',
    body: '',
    upVotesBy: '',
    downVotesBy: '',
    totalComments: '',
  },
};

const replyContextSlice = createSlice({
  name: 'replyContext',
  initialState: replyContextInitialState,
  reducers: {
    setThreadToReply: (state, action) => {
      state.threadContext = action.payload;
    },
    clearThreadToReply: (state) => {
      state.threadContext = replyContextInitialState.threadContext;
    },
  },
});

export const { setThreadToReply, clearThreadToReply } =
  replyContextSlice.actions;

export const selectThreadToReply = (state) => state.replyContext.threadContext;

export default replyContextSlice.reducer;
